(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["voosh-cart-drawer"]) return;
  try {
    
  (function () {
    var drawer = document.querySelector('[data-voosh-drawer]');
    if (!drawer) return;

    var panel = drawer.querySelector('.v-drawer__panel');
    var lastFocused = null;
    var busy = false;

    function routeRoot() {
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    }

    /* --- Open / close -------------------------------------------------------
       hidden is removed before the class is added so the panel has a frame to
       exist at its off-screen position — otherwise it appears already open
       and the slide never plays. */

    function open() {
      if (drawer.classList.contains('is-open')) return;
      lastFocused = document.activeElement;

      drawer.hidden = false;
      requestAnimationFrame(function () {
        drawer.classList.add('is-open');
      });

      document.body.style.overflow = 'hidden';

      var close = drawer.querySelector('.v-drawer__close');
      if (close) close.focus();
    }

    function close() {
      if (!drawer.classList.contains('is-open')) return;
      drawer.classList.remove('is-open');
      document.body.style.overflow = '';

      // Wait for the slide-out before hiding, so it doesn't vanish mid-animation.
      window.setTimeout(function () {
        if (!drawer.classList.contains('is-open')) drawer.hidden = true;
      }, 420);

      // Return focus where it came from, per dialog convention.
      if (lastFocused && lastFocused.focus) lastFocused.focus();
    }

    /* --- Refresh ------------------------------------------------------------
       Re-renders the drawer from Liquid via the Section Rendering API, so
       totals, discount names and money formatting always come from Shopify
       rather than being recalculated here. */

    function refresh() {
      return fetch(routeRoot() + '?sections=voosh-cart-drawer', {
        headers: { Accept: 'application/json' }
      })
        .then(function (response) {
          if (!response.ok) throw new Error('section render failed');
          return response.json();
        })
        .then(function (data) {
          var markup = data['voosh-cart-drawer'];
          if (!markup) return;

          var parsed = new DOMParser().parseFromString(markup, 'text/html');

          ['[data-drawer-body]', '[data-drawer-foot]'].forEach(function (selector) {
            var next = parsed.querySelector(selector);
            var current = drawer.querySelector(selector);
            if (next && current) {
              current.innerHTML = next.innerHTML;
            } else if (next && !current) {
              // Footer only exists when the cart has items.
              panel.appendChild(next);
            } else if (!next && current) {
              current.remove();
            }
          });

          var count = parsed.querySelector('.v-drawer__count');
          var currentCount = drawer.querySelector('.v-drawer__count');
          if (count && currentCount) currentCount.textContent = count.textContent;

          // Keep the header badge in step.
          var headerCount = document.querySelector('[data-cart-count]');
          if (headerCount && count) headerCount.textContent = count.textContent.trim();
        });
    }

    function cartRequest(url, body) {
      if (busy) return Promise.resolve();
      busy = true;

      return fetch(routeRoot() + url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (response) {
          if (!response.ok) throw new Error('cart request failed');
          return refresh();
        })
        .catch(function () {
          // If the cart API is unreachable, the full cart page still works.
          window.location.href = routeRoot() + 'cart';
        })
        .then(function () {
          busy = false;
        });
    }

    /* --- Delegated events ---------------------------------------------------
       Delegation is what lets the drawer body be replaced wholesale on every
       refresh without rebinding anything. */

    drawer.addEventListener('click', function (event) {
      if (event.target.closest('[data-drawer-close]')) {
        event.preventDefault();
        close();
        return;
      }

      var step = event.target.closest('[data-drawer-qty]');
      if (step) {
        cartRequest('cart/change.js', {
          id: step.getAttribute('data-drawer-qty'),
          quantity: parseInt(step.getAttribute('data-to'), 10)
        });
        return;
      }

      var add = event.target.closest('[data-drawer-add]');
      if (add) {
        cartRequest('cart/add.js', {
          items: [{ id: parseInt(add.getAttribute('data-drawer-add'), 10), quantity: 1 }]
        });
      }
    });

    document.addEventListener('keydown', function (event) {
      if (!drawer.classList.contains('is-open')) return;

      if (event.key === 'Escape') {
        close();
        return;
      }

      // Focus trap. A modal dialog must not leak focus to the page behind it.
      if (event.key !== 'Tab') return;

      var focusables = panel.querySelectorAll(
        'a[href], button:not([disabled]), input, select, [tabindex]:not([tabindex="-1"])'
      );
      if (!focusables.length) return;

      var first = focusables[0];
      var last = focusables[focusables.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    // Header cart link opens the drawer instead of navigating.
    document.addEventListener('click', function (event) {
      var toggle = event.target.closest('[data-voosh-cart-toggle]');
      if (!toggle) return;
      event.preventDefault();
      refresh().then(open);
    });

    /* --- Add to cart --------------------------------------------------------
       Bound on document rather than the form, so it runs after any section's
       own submit handler regardless of which script loaded first. The PDP
       already calls preventDefault for multi-box bundles and handles those
       itself; defaultPrevented is how we avoid adding them twice. */

    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (event.defaultPrevented) return;
      if (!form.matches('[data-pdp-form]')) return;

      event.preventDefault();

      var data = new FormData(form);
      fetch(routeRoot() + 'cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: data
      })
        .then(function (response) {
          if (!response.ok) throw new Error('add failed');
          return refresh();
        })
        .then(open)
        .catch(function () {
          form.submit();
        });
    });

    // Fired by the PDP after a multi-box bundle is added.
    document.addEventListener('voosh:cart:updated', function () {
      refresh().then(open);
    });

    /* --- Discount codes -----------------------------------------------------
       Shopify exposes no AJAX endpoint that applies a code and hands back a
       recalculated cart, so this navigates to /discount/<code>. We hand it a
       redirect back to the current page with cart=open, so the customer lands
       exactly where they left off with the drawer already showing the new
       total — which is the closest the platform gets to applying in place.

       Delegated, because the footer is replaced wholesale on every refresh. */

    function applyDiscount(input) {
      var code = (input.value || '').trim();
      var note = drawer.querySelector('[data-discount-note]');

      if (!code) {
        if (note) note.textContent = 'Enter a code first.';
        input.focus();
        return;
      }

      if (note) note.textContent = 'Applying…';

      var back = window.location.pathname + '?cart=open';
      window.location.href =
        routeRoot() + 'discount/' + encodeURIComponent(code) +
        '?redirect=' + encodeURIComponent(back);
    }

    drawer.addEventListener('click', function (event) {
      if (!event.target.closest('[data-discount-apply]')) return;
      var input = drawer.querySelector('[data-discount-input]');
      if (input) applyDiscount(input);
    });

    /* "Enter a code first." answered an empty Apply, then sat there while the
       customer typed a perfectly good code — a complaint about something they
       had already fixed. Clear it the moment they start. */
    drawer.addEventListener('input', function (event) {
      if (!event.target.closest('[data-discount-input]')) return;
      var note = drawer.querySelector('[data-discount-note]');
      if (note && note.textContent) note.textContent = '';
    });

    // Enter submits, as it would in any other field. The drawer has no <form>
    // around this, so the key has to be handled explicitly.
    drawer.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter') return;
      var input = event.target.closest('[data-discount-input]');
      if (!input) return;
      event.preventDefault();
      applyDiscount(input);
    });

    // Coming back from a discount redirect: reopen the drawer so the change
    // is visible immediately, and clean the URL so a refresh or a shared link
    // does not keep forcing the cart open.
    (function () {
      if (window.location.search.indexOf('cart=open') === -1) return;

      refresh().then(open);

      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.delete('cart');
        window.history.replaceState({}, '', url.pathname + url.search + url.hash);
      }
    })();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["voosh-contact"] && !Shopify.designMode) return;
  try {
    
  /* role="status" and role="alert" already announce, but after a full page
     reload the viewport is back at the top with focus on <body>. Moving focus
     to the message means keyboard and screen-reader users continue from the
     outcome rather than tabbing back through the whole form to find it. */
  (function () {
    var alert = document.querySelector('[data-contact-alert]');
    if (!alert) return;

    alert.focus();
    alert.scrollIntoView({ block: 'center' });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["voosh-header"]) return;
  try {
    
  /* --- Theme toggle -------------------------------------------------------
     The stored preference is already applied inline in <head> before paint;
     this only handles switching and keeping the control's label honest. */
  (function () {
    var btn = document.querySelector('[data-theme-toggle]');
    if (!btn) return;

    var label = btn.querySelector('[data-theme-label]');
    var root = document.documentElement;

    function current() {
      var set = root.getAttribute('data-theme');
      if (set) return set;
      // No explicit choice yet — report what the OS is actually giving them.
      return window.matchMedia('(prefers-color-scheme: light)').matches ? 'light' : 'dark';
    }

    function paint() {
      var isLight = current() === 'light';
      btn.setAttribute('aria-pressed', isLight ? 'true' : 'false');
      // aria-label is the action; the visible label is the current state.
      btn.setAttribute('aria-label', isLight ? 'Switch to dark theme' : 'Switch to light theme');
      if (label) label.textContent = isLight ? 'Light' : 'Dark';
    }

    btn.addEventListener('click', function () {
      var next = current() === 'light' ? 'dark' : 'light';
      root.setAttribute('data-theme', next);
      try {
        localStorage.setItem('voosh-theme', next);
      } catch (err) {
        // Preference simply will not persist; the switch still works for
        // this page view, which is better than refusing to switch at all.
      }
      paint();
    });

    // Track the OS while the visitor has not chosen for themselves.
    window.matchMedia('(prefers-color-scheme: light)').addEventListener('change', function () {
      if (!root.getAttribute('data-theme')) paint();
    });

    paint();
  })();

  (function () {
    var toggle = document.querySelector('[data-menu-toggle]');
    var menu = document.querySelector('[data-menu]');
    if (!toggle || !menu) return;

    var panel = menu.querySelector('.v-menu__panel');
    var closeBtn = menu.querySelector('[data-menu-close]');
    var isOpen = false;

    function open() {
      if (isOpen) return;
      isOpen = true;

      // hidden comes off a frame before the class goes on, so the panel has a
      // chance to exist in its start state and the transition actually plays.
      menu.hidden = false;
      requestAnimationFrame(function () {
        menu.classList.add('is-open');
      });

      toggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';

      // Focus the close button rather than the first link: it is the way out,
      // and landing on it means the exit is the first thing announced.
      var first = closeBtn || panel.querySelector('a[href]');
      if (first) first.focus();
    }

    function close(returnFocus) {
      if (!isOpen) return;
      isOpen = false;

      menu.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';

      window.setTimeout(function () {
        if (!isOpen) menu.hidden = true;
      }, 420);

      if (returnFocus) toggle.focus();
    }

    toggle.addEventListener('click', function () {
      isOpen ? close(true) : open();
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        close(true);
      });
    }

    // Any navigation closes the menu. Without this, tapping a link that only
    // changes the hash would leave the overlay covering the page.
    menu.addEventListener('click', function (event) {
      if (event.target.closest('a[href]')) close(false);
    });

    document.addEventListener('keydown', function (event) {
      if (!isOpen) return;

      if (event.key === 'Escape') {
        close(true);
        return;
      }

      if (event.key !== 'Tab') return;

      // Focus trap — a modal must not leak focus to the page behind it.
      var focusables = panel.querySelectorAll('a[href], button:not([disabled])');
      if (!focusables.length) return;

      var first = focusables[0];
      var last = focusables[focusables.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    // Rotating to landscape or resizing past the breakpoint hides the menu in
    // CSS; without this the body would stay scroll-locked with nothing visible
    // to close.
    window.matchMedia('(min-width: 750px)').addEventListener('change', function (event) {
      if (event.matches) close(false);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["voosh-hero"] && !Shopify.designMode) return;
  try {
    
  /* Flavour rotation. Deliberately tiny: it sets one attribute and lets CSS
     custom properties do the rest of the work. */
  (function () {
    var heroes = document.querySelectorAll('[data-voosh-hero]');
    if (!heroes.length) return;

    var ORDER = ['watermelon', 'passionfruit', 'kiwi-lime'];

    heroes.forEach(function (hero) {
      if (hero.dataset.rotate !== 'true') return;

      // Never auto-rotate for reduced-motion users: an unprompted colour
      // change every few seconds is exactly the kind of motion they opted out
      // of. They keep whichever flavour the hero started on.
      if (window.VOOSH && window.VOOSH.reduced) return;

      var interval = parseInt(hero.dataset.interval, 10);
      if (!interval || interval < 2000) interval = 5000;

      var index = ORDER.indexOf(hero.getAttribute('data-flavour'));
      if (index === -1) index = 0;

      var timer = null;

      function advance() {
        index = (index + 1) % ORDER.length;
        hero.setAttribute('data-flavour', ORDER[index]);
      }

      function start() {
        if (timer) return;
        timer = window.setInterval(advance, interval);
      }

      function stop() {
        if (!timer) return;
        window.clearInterval(timer);
        timer = null;
      }

      // Stop cycling once the hero is off screen, and while the tab is hidden.
      // A timer repainting a full-viewport gradient nobody is looking at is
      // pure battery cost on mobile.
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries[0].isIntersecting ? start() : stop();
        }, { threshold: 0.05 }).observe(hero);
      } else {
        start();
      }

      document.addEventListener('visibilitychange', function () {
        document.hidden ? stop() : start();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["voosh-manifesto"] && !Shopify.designMode) return;
  try {
    
  /* Keeps the continuation glow on the hero's current flavour.

     The observer lives here rather than in the hero on purpose: this is the
     section that wants to follow, so it is the section that does the
     following. The hero stays unaware it is being tracked, and a page without
     a hero — every page but the homepage — simply does nothing.

     A MutationObserver rather than a shared timer: the hero already owns the
     cadence, and duplicating an interval would drift out of step with it
     within a few cycles. Watching the one attribute the hero writes means the
     two can never disagree. */
  (function () {
    var glows = document.querySelectorAll('[data-voosh-follow-hero]');
    if (!glows.length) return;

    var hero = document.querySelector('[data-voosh-hero]');
    if (!hero) return;

    function sync() {
      var flavour = hero.getAttribute('data-flavour');
      if (!flavour) return;
      Array.prototype.forEach.call(glows, function (glow) {
        glow.setAttribute('data-flavour', flavour);
      });
    }

    // Once up front, in case the hero is not cycling — its starting flavour
    // still has to win over this section's Liquid fallback.
    sync();

    new MutationObserver(sync).observe(hero, {
      attributes: true,
      attributeFilter: ['data-flavour']
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["voosh-pillars"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var groups = document.querySelectorAll('[data-voosh-pillars]');
    if (!groups.length) return;

    groups.forEach(function (group) {
      var panels = Array.prototype.slice.call(
        group.querySelectorAll('.v-pillars__panel')
      );
      if (!panels.length) return;

      function open(panel) {
        panels.forEach(function (other) {
          var isCurrent = other === panel;
          other.classList.toggle('is-open', isCurrent);

          var trigger = other.querySelector('[data-pillar-trigger]');
          if (trigger) trigger.setAttribute('aria-expanded', isCurrent ? 'true' : 'false');
        });
      }

      panels.forEach(function (panel) {
        var trigger = panel.querySelector('[data-pillar-trigger]');
        if (!trigger) return;

        trigger.addEventListener('click', function () {
          open(panel);
        });

        // Pointer users get it on hover, which makes the row feel alive when
        // scanning. Guarded to real hover devices so a tap on a phone doesn't
        // fire hover and click and open the panel twice.
        if (window.matchMedia('(hover: hover) and (min-width: 990px)').matches) {
          panel.addEventListener('mouseenter', function () {
            open(panel);
          });
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["voosh-popup"]) return;
  try {
    
  (function () {
    var popup = document.querySelector('[data-voosh-popup]');
    if (!popup) return;

    var KEY = 'voosh-popup-seen';
    var panel = popup.querySelector('.v-popup__panel');
    var lastFocused = null;
    var timer = null;

    function seen() {
      try {
        return localStorage.getItem(KEY) === '1';
      } catch (err) {
        return true;
      }
    }

    function remember() {
      try {
        localStorage.setItem(KEY, '1');
      } catch (err) {
        /* nothing to do — it simply will not persist */
      }
    }

    function open() {
      if (popup.classList.contains('is-open')) return;
      lastFocused = document.activeElement;

      popup.hidden = false;
      requestAnimationFrame(function () {
        popup.classList.add('is-open');
      });

      document.body.style.overflow = 'hidden';

      var field = panel.querySelector('input[type="email"]');
      var fallback = panel.querySelector('.v-popup__close');
      if (field) field.focus();
      else if (fallback) fallback.focus();

      remember();
    }

    function close() {
      if (!popup.classList.contains('is-open')) return;
      popup.classList.remove('is-open');
      document.body.style.overflow = '';

      window.setTimeout(function () {
        if (!popup.classList.contains('is-open')) popup.hidden = true;
      }, 420);

      if (lastFocused && lastFocused.focus) lastFocused.focus();
    }

    popup.addEventListener('click', function (event) {
      if (event.target.closest('[data-popup-close]')) close();
    });

    document.addEventListener('keydown', function (event) {
      if (!popup.classList.contains('is-open')) return;

      if (event.key === 'Escape') {
        close();
        return;
      }

      if (event.key !== 'Tab') return;

      var focusables = panel.querySelectorAll(
        'a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])'
      );
      if (!focusables.length) return;

      var first = focusables[0];
      var last = focusables[focusables.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    if (window.location.search.indexOf('customer_posted=true') !== -1) {
      open();
      return;
    }

    if (seen()) return;

    var delay = parseInt(popup.dataset.delay, 10);
    if (!delay || delay < 3000) delay = 15000;

    timer = window.setTimeout(open, delay);

    document.addEventListener('visibilitychange', function () {
      if (!document.hidden || !timer) return;
      window.clearTimeout(timer);
      timer = null;
      if (!seen()) timer = window.setTimeout(open, delay);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["voosh-product-flavours"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('[data-voosh-flavours]');
    if (!sections.length) return;

    sections.forEach(function (section) {
      var options = Array.prototype.slice.call(
        section.querySelectorAll('[data-flavour-option]')
      );
      if (!options.length) return;

      var frames = section.querySelectorAll('[data-flavour-frame]');
      var cta = section.querySelector('[data-flavours-cta]');

      function select(option, moveFocus) {
        var slug = option.getAttribute('data-flavour-option');

        // One attribute write re-themes the section: wash, glow, dots, button
        // fill and focus ring all derive from the accent tokens.
        section.setAttribute('data-flavour', slug);

        options.forEach(function (other) {
          var isCurrent = other === option;
          other.setAttribute('aria-checked', isCurrent ? 'true' : 'false');
          // Roving tabindex: the group stays one tab stop.
          other.setAttribute('tabindex', isCurrent ? '0' : '-1');
        });

        frames.forEach(function (frame) {
          var isCurrent = frame.getAttribute('data-flavour-frame') === slug;
          frame.classList.toggle('is-active', isCurrent);
          // Hide inactive renders from assistive tech — otherwise a screen
          // reader announces every flavour's image at once.
          if (isCurrent) {
            frame.removeAttribute('aria-hidden');
          } else {
            frame.setAttribute('aria-hidden', 'true');
          }
        });

        if (cta) {
          var url = option.getAttribute('data-variant-url');
          if (url) cta.setAttribute('href', url);
        }

        if (moveFocus) option.focus();
      }

      options.forEach(function (option) {
        option.addEventListener('click', function () {
          select(option, false);
        });
      });

      // Arrow keys move within the group and wrap at both ends, per the
      // radiogroup pattern. Home/End jump to the ends.
      section.addEventListener('keydown', function (event) {
        var current = options.indexOf(document.activeElement);
        if (current === -1) return;

        var next = null;

        switch (event.key) {
          case 'ArrowRight':
          case 'ArrowDown':
            next = (current + 1) % options.length;
            break;
          case 'ArrowLeft':
          case 'ArrowUp':
            next = (current - 1 + options.length) % options.length;
            break;
          case 'Home':
            next = 0;
            break;
          case 'End':
            next = options.length - 1;
            break;
          default:
            return;
        }

        event.preventDefault();
        select(options[next], true);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["voosh-product"]) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-voosh-pdp]');
    if (!root) return;

    var dataEl = root.querySelector('[data-pdp-variants]');
    var variants = [];
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (err) {
      // Without variant data the page still works as a plain form post, so
      // fail quietly rather than breaking add-to-cart.
      return;
    }

    var form = root.querySelector('[data-pdp-form]');
    var variantInput = root.querySelector('[data-pdp-variant-input]');
    var priceEl = root.querySelector('[data-pdp-price]');
    var stickyPrice = root.querySelector('[data-pdp-sticky-price]');
    var addBtn = root.querySelector('[data-pdp-add]');
    var addLabel = root.querySelector('[data-pdp-add-label]');
    var statusEl = root.querySelector('[data-pdp-status]');
    var frames = root.querySelectorAll('[data-pdp-frame]');
    var flavourBtns = Array.prototype.slice.call(root.querySelectorAll('[data-pdp-flavour]'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-pdp-thumb]'));
    var shotImg = root.querySelector('[data-pdp-shot]');
    var tierBtns = Array.prototype.slice.call(root.querySelectorAll('[data-bundle-tier]'));
    var mix = root.querySelector('[data-bundle-mix]');
    var sticky = root.querySelector('[data-pdp-sticky]');

    var currentVariant = variants[0];
    var currentTier = 1;

    function findById(id) {
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === String(id)) return variants[i];
      }
      return null;
    }

    /* --- Tier totals -------------------------------------------------------
       Re-read from the selected variant so the tier prices stay correct if
       flavours are ever priced differently. */
    function paintTiers() {
      tierBtns.forEach(function (btn) {
        var tier = btn.getAttribute('data-bundle-tier');
        var prices = currentVariant.tiers && currentVariant.tiers[tier];
        if (!prices) return;

        var out = btn.querySelector('[data-bundle-total]');
        if (out) out.textContent = prices.net;

        // Only discounted tiers render a struck price, so this is a no-op on
        // tier 1. The hidden "Normally" label sits outside the <s>, so writing
        // textContent here cannot clobber it.
        var was = btn.querySelector('[data-bundle-was]');
        if (was && prices.was) was.textContent = prices.was;
      });
    }

    /* --- Variant selection -------------------------------------------------- */
    function selectVariant(variant, moveFocus, btn) {
      if (!variant) return;
      currentVariant = variant;

      // One write re-themes the page: wash, glow, dots, tier outline, focus.
      root.setAttribute('data-flavour', variant.flavour);
      if (variantInput) variantInput.value = variant.id;

      if (priceEl) priceEl.textContent = variant.priceText;
      if (stickyPrice) stickyPrice.textContent = variant.priceText;

      flavourBtns.forEach(function (other) {
        var isCurrent = other.getAttribute('data-variant-id') === String(variant.id);
        other.setAttribute('aria-checked', isCurrent ? 'true' : 'false');
        other.setAttribute('tabindex', isCurrent ? '0' : '-1');
      });

      frames.forEach(function (frame) {
        var isCurrent = frame.getAttribute('data-pdp-frame') === variant.flavour;
        frame.classList.toggle('is-active', isCurrent);
        if (isCurrent) {
          frame.removeAttribute('aria-hidden');
        } else {
          frame.setAttribute('aria-hidden', 'true');
        }
      });

      // The loop above has already dropped the thumbnail frame, since "shot"
      // matches no flavour. This just stops a thumbnail still claiming to be
      // the one on screen.
      thumbs.forEach(function (thumb) {
        thumb.setAttribute('aria-pressed', 'false');
      });

      if (addBtn) {
        addBtn.disabled = !variant.available;
        if (addLabel) {
          addLabel.textContent = variant.available
            ? (addBtn.getAttribute('data-label') || addLabel.textContent)
            : 'Sold out';
        }
      }

      // Box 1 mirrors the flavour picker, so the bundle always opens showing
      // the flavour the customer already chose above.
      var boxOne = root.querySelector('[data-bundle-select="1"]');
      if (boxOne && boxOne.value !== String(variant.id)) boxOne.value = variant.id;

      paintTiers();

      // Keep the URL shareable without adding a history entry per click.
      if (variant.url && window.history && window.history.replaceState) {
        window.history.replaceState({}, '', variant.url);
      }

      if (moveFocus && btn) btn.focus();
    }

    flavourBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        selectVariant(findById(btn.getAttribute('data-variant-id')), false, btn);
      });
    });

    // Arrow-key support for the flavour radiogroup.
    if (flavourBtns.length) {
      flavourBtns[0].parentNode.addEventListener('keydown', function (event) {
        var i = flavourBtns.indexOf(document.activeElement);
        if (i === -1) return;
        var next = null;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (i + 1) % flavourBtns.length;
        else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (i - 1 + flavourBtns.length) % flavourBtns.length;
        else return;
        event.preventDefault();
        var btn = flavourBtns[next];
        selectVariant(findById(btn.getAttribute('data-variant-id')), true, btn);
      });
    }

    /* --- Thumbnails ----------------------------------------------------------
       These were inert list items: they looked like a gallery and did nothing.
       Each is now a button that points the one shot frame at its image and
       takes the gallery over from the flavour frames. Picking a flavour hands
       it straight back, which is why neither feature needs to know about the
       other. */
    if (shotImg && thumbs.length) {
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          shotImg.src = thumb.getAttribute('data-shot-src');
          shotImg.srcset = thumb.getAttribute('data-shot-srcset') || '';
          shotImg.sizes = '(min-width: 990px) 48vw, 92vw';
          shotImg.alt = thumb.getAttribute('data-shot-alt') || '';

          frames.forEach(function (frame) {
            var isShot = frame.getAttribute('data-pdp-frame') === 'shot';
            frame.classList.toggle('is-active', isShot);
            if (isShot) {
              frame.removeAttribute('aria-hidden');
            } else {
              frame.setAttribute('aria-hidden', 'true');
            }
          });

          thumbs.forEach(function (other) {
            other.setAttribute('aria-pressed', other === thumb ? 'true' : 'false');
          });
        });
      });
    }

    /* --- Bundle tiers ------------------------------------------------------- */
    function selectTier(tier) {
      currentTier = parseInt(tier, 10) || 1;

      tierBtns.forEach(function (btn) {
        var isCurrent = parseInt(btn.getAttribute('data-bundle-tier'), 10) === currentTier;
        btn.setAttribute('aria-checked', isCurrent ? 'true' : 'false');
        btn.setAttribute('tabindex', isCurrent ? '0' : '-1');
      });

      if (!mix) return;

      // One picker per box, box 1 included — it mirrors the flavour chosen
      // above rather than being left implied.
      mix.hidden = currentTier < 2;
      for (var box = 1; box <= 3; box++) {
        var pick = mix.querySelector('[data-bundle-pick="' + box + '"]');
        if (pick) pick.hidden = box > currentTier;
      }
    }

    tierBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        selectTier(btn.getAttribute('data-bundle-tier'));
      });
    });

    // Changing box 1 changes the whole page's flavour, since box 1 and the
    // picker above are the same choice shown twice.
    var boxOneSelect = root.querySelector('[data-bundle-select="1"]');
    if (boxOneSelect) {
      boxOneSelect.addEventListener('change', function () {
        selectVariant(findById(boxOneSelect.value), false, null);
      });
    }

    /* --- Add to cart --------------------------------------------------------
       A single box posts the form normally. Multi-box bundles need several
       line items, which a plain form cannot express, so those go through the
       AJAX cart API. If that request fails we fall back to a native submit
       rather than leaving the customer with a dead button. */
    if (form) {
      form.addEventListener('submit', function (event) {
        if (currentTier < 2) return; // native post is fine

        event.preventDefault();

        var items = [];
        for (var box = 1; box <= currentTier; box++) {
          var select = root.querySelector('[data-bundle-select="' + box + '"]');
          if (select && select.value) {
            items.push({ id: parseInt(select.value, 10), quantity: 1 });
          } else if (box === 1) {
            // Box 1 falls back to the flavour picker if its select is missing.
            items.push({ id: currentVariant.id, quantity: 1 });
          }
        }

        if (addBtn) addBtn.disabled = true;
        if (statusEl) statusEl.textContent = 'Adding…';

        fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (response) {
            if (!response.ok) throw new Error('cart/add failed');
            return response.json();
          })
          .then(function () {
            if (statusEl) statusEl.textContent = currentTier + ' boxes added to your cart.';
            if (addBtn) addBtn.disabled = false;
            // The drawer lands in stage 5 and will listen for this.
            document.dispatchEvent(new CustomEvent('voosh:cart:updated'));
          })
          .catch(function () {
            if (statusEl) statusEl.textContent = '';
            if (addBtn) addBtn.disabled = false;
            form.submit();
          });
      });
    }

    /* --- Sticky bar ---------------------------------------------------------
       Shown only once the real button has scrolled out of view. aria-hidden
       and tabindex are kept in step so the duplicate button is never a phantom
       tab stop while invisible. */
    if (sticky && addBtn && 'IntersectionObserver' in window) {
      var stickyBtn = sticky.querySelector('[data-pdp-sticky-add]');

      new IntersectionObserver(function (entries) {
        var visible = !entries[0].isIntersecting;
        sticky.classList.toggle('is-visible', visible);
        sticky.setAttribute('aria-hidden', visible ? 'false' : 'true');
        if (stickyBtn) stickyBtn.setAttribute('tabindex', visible ? '0' : '-1');
      }, { threshold: 0 }).observe(addBtn);
    }

    // Seed state from what the server rendered.
    var initial = findById(variantInput ? variantInput.value : null);
    if (initial) currentVariant = initial;
    if (addBtn && addLabel) addBtn.setAttribute('data-label', addLabel.textContent.trim());
    paintTiers();
    selectTier(1);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["voosh-scroll-story"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('[data-voosh-story]');
    if (!sections.length) return;

    if (window.VOOSH && window.VOOSH.reduced) return;

    sections.forEach(function (section) {
      var track = section.querySelector('.v-story__track');
      var stage = section.querySelector('.v-story__stage');
      var beats = Array.prototype.slice.call(section.querySelectorAll('.v-story__beat'));
      var frames = Array.prototype.slice.call(section.querySelectorAll('.v-story__frame'));
      if (!track || !stage || !beats.length) return;

      var ticking = false;
      var active = -1;
      // Cached so the per-frame path never reads layout — measuring inside the
      // scroll handler is what turns a smooth pin into jank.
      var top = 0;
      var span = 1;

      function measure() {
        var rect = track.getBoundingClientRect();
        top = rect.top + window.scrollY;
        span = Math.max(track.offsetHeight - stage.offsetHeight, 1);
      }

      function frame() {
        ticking = false;

        var progress = (window.scrollY - top) / span;
        if (progress < 0) progress = 0;
        if (progress > 1) progress = 1;

        section.style.setProperty('--progress', progress.toFixed(4));

        // Map progress onto a beat, biased slightly forward so the last beat
        // is reached before the section unpins rather than exactly at the end.
        var index = Math.min(
          beats.length - 1,
          Math.floor(progress * beats.length * 1.08)
        );

        if (index === active) return;
        active = index;

        beats.forEach(function (beat, i) {
          beat.classList.toggle('is-active', i <= index);
        });

        // Beats accumulate — every one up to the active index stays lit. The
        // render does not: exactly one frame is shown, the one belonging to
        // the beat being read.
        frames.forEach(function (frameEl, i) {
          frameEl.classList.toggle('is-current', i === index);
        });
      }

      function onScroll() {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(frame);
      }

      // Added before the first frame() so the CSS hands frame visibility over
      // to the script in the same paint that the script first sets it —
      // otherwise the first frame's fallback and the script's choice are both
      // live for a moment and two images cross-fade on load.
      section.classList.add('is-ready');

      measure();
      frame();

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', function () {
        measure();
        onScroll();
      }, { passive: true });

      // Fonts landing after first paint change the stage height, which would
      // leave the cached measurement wrong for the life of the page.
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(function () {
          measure();
          onScroll();
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
